import { useMemo } from 'react';

export interface UseCurrentTotalPagesProperties {
  filteredRowsCount: number;
  rowsPerPage: number;
}

const useCurrentTotalPages = ({ filteredRowsCount, rowsPerPage }: UseCurrentTotalPagesProperties): number =>
  useMemo(() => Math.ceil(filteredRowsCount / rowsPerPage), [filteredRowsCount, rowsPerPage]);

export default useCurrentTotalPages;
